import React, { Component } from "react";
import PropTypes from "prop-types";
import { ToastContainer, toast, cssTransition } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import i18n from "i18n-react";

const Zoom = cssTransition({
  enter: "zoomIn",
  exit: "zoomOut",
  duration: [500, 800],
});

export default class ArrangeTheWords extends Component {
  constructor(props) {
    super(props);
    const { words } = props;

    this.state = {
      blanks: Array(words.length).fill(null),
      availableWords: this.shuffleArray([...words]),
      answerStyle: false,
      isIncorrect: false,
    };

    this.handleWordSelect = this.handleWordSelect.bind(this);
    this.handleRemoveWord = this.handleRemoveWord.bind(this);
  }

  shuffleArray(array) {
    const arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  isAnswerCorrect(blanks, words) {
    return blanks.every(
      (word, i) => word?.toLowerCase() === words[i]?.toLowerCase(),
    );
  }

  checkAnswer() {
    const { blanks } = this.state;
    const {
      words,
      correctAnswerText,
      contentComplete,
      incorrectAnswerText,
      error,
    } = this.props;

    const isCorrect = this.isAnswerCorrect(blanks, words);

    if (isCorrect) {
      this.setState({ answerStyle: true, isIncorrect: false });

      toast.success(correctAnswerText, {
        position: "top-center",
        transition: Zoom,
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      contentComplete();
    } else {
      toast.error(incorrectAnswerText, {
        position: "top-center",
        transition: Zoom,
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      error();
      this.setState({ answerStyle: false, isIncorrect: true });
    }
  }

  handleWordSelect(word) {
    this.setState((prevState) => {
      const nextBlankIndex = prevState.blanks.findIndex((b) => b === null);
      if (nextBlankIndex === -1) return null;

      const newBlanks = [...prevState.blanks];
      newBlanks[nextBlankIndex] = word;

      const newAvailableWords = prevState.availableWords.filter(
        (w) => w !== word,
      );

      return {
        blanks: newBlanks,
        availableWords: newAvailableWords,
      };
    });
  }

  handleRemoveWord(index) {
    this.setState((prevState) => {
      const wordToReturn = prevState.blanks[index];
      if (!wordToReturn) return null;

      const newBlanks = [...prevState.blanks];
      newBlanks[index] = null;

      return {
        blanks: newBlanks,
        availableWords: [...prevState.availableWords, wordToReturn],
      };
    });
  }

  render() {
    const { question, disableHeader, title } = this.props;
    const { blanks, availableWords } = this.state;

    const questionParts = question.split(/\[blank\]/g);

    return (
      <div className="arrangeWords__container">
        {!disableHeader && (
          <div className="arrange__header">{title && <h1>{title}</h1>}</div>
        )}

        <p className="arrangeWords__description">
          {i18n.translate("questions.arrangeTheWords")}
        </p>

        <div className="arrangeWords__sentence">
          <h4>
            {questionParts.map((part, i) => (
              <span key={i}>
                {part}
                {i < blanks.length &&
                  (blanks[i] !== null ? (
                    <span
                      onClick={() => this.handleRemoveWord(i)}
                      className={`arrangeWords__filledBlank ${
                        this.state.answerStyle ? "correct" : ""
                      } ${this.state.isIncorrect ? "incorrect" : ""}`}
                    >
                      {blanks[i]}
                    </span>
                  ) : (
                    <span className="arrangeWords__blank">_____</span>
                  ))}
              </span>
            ))}
          </h4>
        </div>

        <div className="arrangeWords__availableWords">
          {availableWords.map((word, i) => (
            <button
              key={`${word}-${i}`}
              onClick={() => this.handleWordSelect(word)}
              className="arrangeWords__availableWordButton"
            >
              {word}
            </button>
          ))}
        </div>

        <ToastContainer transition={Zoom} />
        <button
          onClick={() => {
            this.checkAnswer();
          }}
          style={this.state.answerStyle ? { backgroundColor: "#6cd488" } : null}
        >
          Submit
        </button>
      </div>
    );
  }
}

ArrangeTheWords.propTypes = {
  words: PropTypes.arrayOf(PropTypes.string).isRequired,
  question: PropTypes.string.isRequired,
  correctAnswerText: PropTypes.string,
  contentComplete: PropTypes.func,
  disableHeader: PropTypes.bool,
  title: PropTypes.string,
};

ArrangeTheWords.defaultProps = {
  correctAnswerText: "Correct!",
  contentComplete: () => {},
  disableHeader: false,
  title: null,
};
